import { reducerWithInitialState } from "typescript-fsa-reducers";

import { Modal, modalOpened, modalClosed } from "../actions/Modal";

export interface ModalsState {
  currentModal: Modal | null;
}

const initialState: ModalsState = {
  currentModal: null,
};

const modalsReducer = reducerWithInitialState(initialState)
  .case(modalOpened, (state, action) => {
    return { ...state, currentModal: action };
  })
  .case(modalClosed, (state, action) => {
    const isCurrentModal =
      state.currentModal && action.name === state.currentModal.name && action.id === state.currentModal.id;
    return { ...state, currentModal: isCurrentModal ? null : state.currentModal };
  });

export default modalsReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/modals.ts